import { SideNav, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MessagingSummaryResourceInfo } from '../MessagingSummaryResource/MessagingSummaryResource';
export interface SecuredMessagingSideNavLinkProps {
  path: string;
}

const SecuredMessagingSideNavLink: FC<SecuredMessagingSideNavLinkProps> = ({ path }) => {
  const { t } = useTranslation('SecuredMessagingSideNavLink');
  const newMessageCount: number = useScopedSelector(MessagingSummaryResourceInfo.dataDst);
  const count = newMessageCount > 0 ? newMessageCount : null;
  return (
    <>
      {
        (newMessageCount > 0 || newMessageCount === 0) &&
        <SideNav.Link data-testid="MyMessages" to={path} badgeContent={count} badgeType={t('badgeType')}>
          {t('title')}
        </SideNav.Link>
      }
    </>
  );
};

export default SecuredMessagingSideNavLink;
